var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.932 0L7.173 5.759 1.414 0 0 1.414l5.759 5.759L0 12.932l1.414 1.414 5.759-5.759 5.759 5.759 1.414-1.414-5.759-5.759 5.759-5.759z","fillRule":"evenodd"}));
}

X.defaultProps = {"width":"15","height":"15"};

module.exports = X;

X.default = X;
